module.exports = __webpack_public_path__ + "img/loading.8c0d51ab.gif";